import { render, staticRenderFns } from "./confirmedActionButton.vue?vue&type=template&id=452dff8b"
import script from "./confirmedActionButton.vue?vue&type=script&lang=js"
export * from "./confirmedActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports